import { RecordingTypes } from '@carboncopyco/types';

export const DONT_SHOW_KEY = 'dontShowThisAgain';
export const DONT_SHOW_UPDATE_KEY = 'dontShowThisAgain';
export const APP_VIEW = 'APP';
export const APP_MODAL_Z_INDEX = 99999;

export const DefaultRecordingTypesList = [
  RecordingTypes.native,
  RecordingTypes.dynamic,
];

// Bad tooltip implementation hack (because it adds extra divs to the DOM)
// If we remove TooltipBubble, we have to remove this hack
export const tooltipHackClasses =
  '[&>div]:flex [&>div]:flex-grow [&>div]:shrink [&>div]:basis-auto [&>div]:min-w-0 [&>div>div]:flex [&>div>div]:flex-grow [&>div>div]:shrink [&>div>div]:basis-auto [&>div>div]:min-w-0 [&>div>div]:items-center';
